/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_strung = /** @type {(inputs: {}) => string} */ () => {
	return `Je navlečený?`
};

const da_attributes_strung = /** @type {(inputs: {}) => string} */ () => {
	return `opstrenget`
};

const de_attributes_strung = /** @type {(inputs: {}) => string} */ () => {
	return `bespannt`
};

const en_attributes_strung = /** @type {(inputs: {}) => string} */ () => {
	return `strung`
};

const es_attributes_strung = /** @type {(inputs: {}) => string} */ () => {
	return `encordada`
};

const fr_attributes_strung = /** @type {(inputs: {}) => string} */ () => {
	return `Cordée`
};

const hu_attributes_strung = /** @type {(inputs: {}) => string} */ () => {
	return `Kifeszített`
};

const it_attributes_strung = /** @type {(inputs: {}) => string} */ () => {
	return `incordata`
};

const nl_attributes_strung = /** @type {(inputs: {}) => string} */ () => {
	return `bespannen`
};

const pl_attributes_strung = /** @type {(inputs: {}) => string} */ () => {
	return `naciągiem`
};

const pt_attributes_strung = /** @type {(inputs: {}) => string} */ () => {
	return `encordoada`
};

const sv_attributes_strung = /** @type {(inputs: {}) => string} */ () => {
	return `strängad`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_strung = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_strung(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_strung", locale)
	if (locale === "cs") return cs_attributes_strung(inputs)
	if (locale === "da") return da_attributes_strung(inputs)
	if (locale === "de") return de_attributes_strung(inputs)
	if (locale === "en") return en_attributes_strung(inputs)
	if (locale === "es") return es_attributes_strung(inputs)
	if (locale === "fr") return fr_attributes_strung(inputs)
	if (locale === "hu") return hu_attributes_strung(inputs)
	if (locale === "it") return it_attributes_strung(inputs)
	if (locale === "nl") return nl_attributes_strung(inputs)
	if (locale === "pl") return pl_attributes_strung(inputs)
	if (locale === "pt") return pt_attributes_strung(inputs)
	return sv_attributes_strung(inputs)
};
export { attributes_strung as "attributes.strung" }